import classNames from "classnames";
import React, { FC, useCallback, useState } from "react";

import { Flex, IFlexProps } from "@/eworkitComponents";

import "./list.scss";

export interface IListProps extends IFlexProps {
  innerShadows?: boolean;
}

export const List: FC<IListProps> = ({ className, innerShadows = true, children, ...props }) => {
  const [reachedTop, setReachedTop] = useState(true);
  const [reachedBottom, setReachedBottom] = useState(false);

  const classes = classNames(
    "list",
    {
      "list--top-shadow": !reachedTop && innerShadows,
      "list--bottom-shadow": !reachedBottom && innerShadows,
    },
    className,
  );

  const handleScroll = useCallback(
    (event: any) => {
      const target = event.target;
      const rTop = target.scrollTop === 0;
      const rBottom = target.scrollHeight - target.scrollTop === target.clientHeight;

      if (rTop !== reachedTop) {
        setReachedTop(rTop);
      }

      if (rBottom !== reachedBottom) {
        setReachedBottom(rBottom);
      }
    },
    [reachedTop, setReachedTop, reachedBottom, setReachedBottom],
  );

  return (
    <Flex className={classes} direction="column" {...props}>
      <Flex className="list__container" direction="column" onScroll={innerShadows ? handleScroll : undefined}>
        {children}
      </Flex>
    </Flex>
  );
};
